// src/layout/footer.tsx
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const links = [
    { href: "https://gatetard.in/about", label: "About" },
    { href: "https://gatetard.in/contact", label: "Contact" },
    { href: "https://gatetard.in/privacy-policy", label: "Privacy" },
    { href: "https://gatetard.in/terms", label: "Terms" },
  ];

  return (
    <footer className="border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="flex flex-wrap justify-center sm:justify-start gap-5">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
          <span className="text-xs text-muted-foreground">
            {currentYear} GateTard
          </span>
        </div>
      </div>
    </footer>
  );
}
